// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F0_B","left":"styles_left__z6cX7"};